export const round = (number: number, places: number) =>
  Math.round(number * 10 ** places) / 10 ** places;

export const decodeUrlSafeBase64 = (urlSafe: string ) => {
  const padding = Array((4 - urlSafe.length % 4) % 4 + 1).join("=");
  const regularB64 = urlSafe.replaceAll("-", "+").replaceAll("_", "/") + padding;
  return atob(regularB64);
};